import React from 'react';
import { Language } from 'language/Language';
import { legacyDownloadStrings as strings } from './strings';

const LegacyDownload = () => {
  const language = Language();
  const getLink = async (platform) => {
    const link = platform === 'Windows'
      ? 'https://f002.backblazeb2.com/file/Sony-artifacts/RACSInstaller/PluginBuilds/360_WalkMix_Creator_152_direct_installer/Audio_Futures_360_WalkMix_Creator_v1_5_2.exe'
      : 'https://f002.backblazeb2.com/file/Sony-artifacts/RACSInstaller/PluginBuilds/360_WalkMix_Creator_152_direct_installer/Audio_Futures_360_WalkMix_Creator_v1_5_2.pkg';
    window.location.href = link;
  };
  return (
    <div className='legacy-download'>
      <h2>{strings[language].title}</h2>
      <p>{strings[language].description}</p>
      <div style={{ display: 'flex', flexWrap: 'wrap', marginTop: '50px' }}>
        <button
          className='table-content__link download-link legacy-download_button'
          onClick={() => getLink('Windows')}
          type='button'
        >
          <h3>{strings[language].buttonWin}</h3>
        </button>
        <button
          className='table-content__link download-link legacy-download_button'
          onClick={() => getLink('MACos')}
          type='button'
        >
          <h3>{strings[language].buttonMac}</h3>
        </button>
      </div>
    </div>
  );
};

export default LegacyDownload;
